import { React } from 'libs/react';
import { Money } from 'components/Money';
import { Text } from 'components/Text';
import { useDealOtherFeesBreakdown } from 'modules/deal/hooks/useDealOtherFeesBreakdown';
import './DealOtherFeesBreakdownSection.scss';
/**
 * @function getTypeLabel
 * @since 1.0.0
 * @hidden
 */
function getTypeLabel(type) {
    switch (type) {
        case 'package':
            return t('Package');
        case 'option':
            return t('Option');
        default:
            return t('Item');
    }
}
/**
 * @function formatQuantity
 * @since 1.0.0
 * @hidden
 */
function formatQuantity(value) {
    return Number.isInteger(value) ? String(value) : value.toFixed(2);
}
/**
 * @function OtherFeeBlock
 * @since 1.0.0
 * @hidden
 */
function OtherFeeBlock(props) {
    const { fee } = props;
    const isQuantity = fee.type === 'QUANTITY';
    const isFixed = fee.type === 'FIXED';
    const baseLabel = isQuantity ? t('Quantity') : t('Amount');
    return (React.createElement("div", { className: "deal-other-fees-breakdown-fee" },
        React.createElement("div", { className: "deal-other-fees-breakdown-fee-header" },
            React.createElement(Text, { className: "deal-other-fees-breakdown-fee-title", value: fee.title }),
            fee.formula && (React.createElement(Text, { className: "deal-other-fees-breakdown-fee-formula", value: fee.formula })),
            !isFixed && (React.createElement(Text, { className: "deal-other-fees-breakdown-fee-restriction", value: fee.restrictionLabel }))),
        isFixed ? null : fee.lines.length === 0 ? (React.createElement(Text, { className: "deal-other-fees-breakdown-empty", value: t('No items included in this fee') })) : (React.createElement("table", { className: "deal-other-fees-breakdown-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, t('Line')),
                    React.createElement("th", null, t('Type')),
                    React.createElement("th", { className: "column-amount" }, baseLabel),
                    React.createElement("th", { className: "column-amount" }, t('Contribution')))),
            React.createElement("tbody", null, fee.lines.map((line) => (React.createElement("tr", { key: line.id },
                React.createElement("td", { "data-label": t('Line') },
                    React.createElement(Text, { className: "deal-other-fees-breakdown-table-value", value: line.name })),
                React.createElement("td", { "data-label": t('Type') },
                    React.createElement(Text, { className: "deal-other-fees-breakdown-table-value", value: getTypeLabel(line.type) })),
                React.createElement("td", { "data-label": baseLabel, className: "column-amount" }, isQuantity ? (React.createElement(Text, { className: "deal-other-fees-breakdown-table-value", value: formatQuantity(line.quantity) })) : (React.createElement(Money, { value: line.amount }))),
                React.createElement("td", { "data-label": t('Contribution'), className: "column-amount" },
                    React.createElement(Money, { value: line.contribution })))))))),
        React.createElement("div", { className: "deal-other-fees-breakdown-fee-footer" },
            React.createElement(Text, { value: fee.title }),
            React.createElement(Money, { value: fee.price }))));
}
/**
 * @component DealOtherFeesBreakdownSection
 * @since 1.0.0
 *
 * Lists, for each automatically calculated other fee, the deal items,
 * options and packages that are included in its base (percentage subtotal
 * or quantity), along with each line's contribution to the fee total.
 */
export function DealOtherFeesBreakdownSection(props) {
    const { deal } = props;
    const { fees, total } = useDealOtherFeesBreakdown(deal);
    if (fees.length === 0) {
        return (React.createElement("div", { className: "deal-other-fees-breakdown-section" },
            React.createElement(Text, { className: "deal-other-fees-breakdown-empty", value: t('No automatic other fees') })));
    }
    return (React.createElement("div", { className: "deal-other-fees-breakdown-section" },
        fees.map((fee) => (React.createElement(OtherFeeBlock, { key: fee.id, fee: fee }))),
        React.createElement("div", { className: "deal-other-fees-breakdown-footer" },
            React.createElement("div", { className: "deal-other-fees-breakdown-footer-row deal-other-fees-breakdown-footer-row--total" },
                React.createElement(Text, { value: t('Other fees') }),
                React.createElement(Money, { value: total })))));
}
